import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Field } from '../Fuse';
import FuseInfoTooltip from './FuseTooltip/FuseInfoTooltip';

/**
 * This is a generic wrapper around a component, whereby the ReadOnly property is NOT passed to the component,
 * but instead a label and a value is rendered. A few of the controls follow this principle for their "read only"
 * state, at least for the redesigned policy. The existing fuse controls already define a readOnly property
 * as a sort-of-an-alias for 'disable'. Even though it looks like it's not used anywhere but storybook,
 * its assumed QA are somewhat overloaded and if its possible for policy stuff to be merged without a general regress,
 * that's preferred. Long term we would ideally get rid of this and use the original component,
 * or reimplement the old fuse components into their ReadOnly wrappers.
 * */
class FuseReadOnlyComponent extends Component {
    static propTypes = {
        component: PropTypes.func,
        readOnly: PropTypes.bool,
        readOnlyLabel: PropTypes.string,
        readOnlyValue: PropTypes.node,
        className: PropTypes.string,
        qa: PropTypes.string,
        tooltip: PropTypes.node,
        tooltipProps: PropTypes.shape(FuseInfoTooltip.propTypes),
    };

    renderReadOnly = () => {
        const { readOnlyLabel, readOnlyValue, className, qa, tooltip, tooltipProps } = this.props;

        return <Field
            className={className}
            label={readOnlyLabel}
            tooltip={tooltip}
            tooltipProps={tooltipProps}
            data-qa={qa}
        >{readOnlyValue}</Field>;
    };

    render() {
        const {
            component,
            readOnly,
            readOnlyLabel,
            readOnlyValue,
            ...otherProps
        } = this.props;

        if (readOnly) {
            return this.renderReadOnly();
        }
        return React.createElement(component, otherProps);
    }
}

export default observer(FuseReadOnlyComponent);
